import RegisteredAction from '../registered-action';
import { Task } from './task';

export abstract class ExplicitlyCompletableTask extends Task {
  complete?: boolean;

  registeredActions?: RegisteredAction[];

  // for display in placer planning only
  executedClass?: string;
  executedIconClass?: string;
  executedCircle?: string;
  executedTimeString?: string;

  constructor() {
    super();
    this.type = 'ExplicitlyCompletableTask';
  }
}
